// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import SurveyStepElementOption from "./survey-step-element-option.js"
import TeamSurveyStepElement from "./team-survey-step-element.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "survey_step_element_option_id": {
      "column": {
        "default": null,
        "name": "survey_step_element_option_id",
        "null": true,
        "type": null
      },
      "name": "survey_step_element_option_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_survey_step_element_id": {
      "column": {
        "default": null,
        "name": "team_survey_step_element_id",
        "null": false,
        "type": null
      },
      "name": "team_survey_step_element_id",
      "selected_by_default": null,
      "translated": null
    },
    "text": {
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      },
      "name": "text",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TeamSurveyStepElementAnswer",
  "collectionKey": "team_survey_step_element_answers",
  "collectionName": "team_survey_step_element_answers",
  "i18nKey": "team_survey_step_element_answer",
  "camelizedLower": "teamSurveyStepElementAnswer",
  "name": "TeamSurveyStepElementAnswer",
  "nameDasherized": "team-survey-step-element-answer",
  "pluralName": "team_survey_step_element_answers",
  "ransackable_associations": [
    {
      "className": "TeamSurveyStepElementAnswer::Audit",
      "collectionName": "team_survey_step_element_answer_audits",
      "foreignKey": "team_survey_step_element_answer_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswerAudit",
      "through": null
    },
    {
      "className": "TeamSurveyStepElementAnswer::Audit",
      "collectionName": "team_survey_step_element_answer_audits",
      "foreignKey": "team_survey_step_element_answer_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "TeamSurveyStepElementAnswerAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOption",
      "collectionName": "survey_step_element_options",
      "foreignKey": "survey_step_element_option_id",
      "name": "option",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElementOption",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "team"
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "has_one",
      "resource_name": "SchoolClassCheckIn",
      "through": "team_survey"
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "has_one",
      "resource_name": "SurveyStepElement",
      "through": "team_survey_step_element"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "team_survey_step"
    },
    {
      "className": "TeamSurveyStep",
      "collectionName": "team_survey_steps",
      "foreignKey": "team_survey_step_id",
      "name": "team_survey_step",
      "macro": "has_one",
      "resource_name": "TeamSurveyStep",
      "through": "team_survey_step_element"
    },
    {
      "className": "TeamSurveyStepElement",
      "collectionName": "team_survey_step_elements",
      "foreignKey": "team_survey_step_element_id",
      "name": "team_survey_step_element",
      "macro": "belongs_to",
      "resource_name": "TeamSurveyStepElement",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "survey_step_element_option_id",
      "column": {
        "default": null,
        "name": "survey_step_element_option_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "team_survey_step_element_id",
      "column": {
        "default": null,
        "name": "team_survey_step_element_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "text",
      "column": {
        "default": null,
        "name": "text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SurveyStepElementOption",
      "collectionName": "survey_step_element_options",
      "foreignKey": "survey_step_element_option_id",
      "name": "option",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElementOption",
      "through": null
    },
    {
      "className": "TeamSurveyStepElement",
      "collectionName": "team_survey_step_elements",
      "foreignKey": "team_survey_step_element_id",
      "name": "team_survey_step_element",
      "macro": "belongs_to",
      "resource_name": "TeamSurveyStepElement",
      "through": null
    }
  ],
  "paramKey": "team_survey_step_element_answer",
  "primaryKey": "id"
}

/** Frontend model for TeamSurveyStepElementAnswer. */
export default class TeamSurveyStepElementAnswer extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  surveyStepElementOptionId() {
    return this.readAttributeUnderscore("survey_step_element_option_id")
  }

  /** @returns {boolean} */
  hasSurveyStepElementOptionId() {
    const value = this.surveyStepElementOptionId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  teamSurveyStepElementId() {
    return this.readAttributeUnderscore("team_survey_step_element_id")
  }

  /** @returns {boolean} */
  hasTeamSurveyStepElementId() {
    const value = this.teamSurveyStepElementId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  text() {
    return this.readAttributeUnderscore("text")
  }

  /** @returns {boolean} */
  hasText() {
    const value = this.text()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./survey-step-element-option.js").default | null} */
  option() {
    return this._readBelongsToReflection({modelClass: SurveyStepElementOption, reflectionName: "option"})
  }

  /** @returns {Promise<import("./survey-step-element-option.js").default | null>} */
  loadOption() {
    if (!("surveyStepElementOptionId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepElementOptionId")

    const id = this.surveyStepElementOptionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "option",
        model: this,
        modelClass: SurveyStepElementOption
      },
      {ransack}
    )
  }

  /** @returns {import("./team-survey-step-element.js").default | null} */
  teamSurveyStepElement() {
    return this._readBelongsToReflection({modelClass: TeamSurveyStepElement, reflectionName: "team_survey_step_element"})
  }

  /** @returns {Promise<import("./team-survey-step-element.js").default | null>} */
  loadTeamSurveyStepElement() {
    if (!("teamSurveyStepElementId" in this)) throw new Error("Foreign key method wasn't defined: teamSurveyStepElementId")

    const id = this.teamSurveyStepElementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team_survey_step_element",
        model: this,
        modelClass: TeamSurveyStepElement
      },
      {ransack}
    )
  }
}
